<template>
  <div class="modal is-active"  >
        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head is-size-4">
            <p v-if="modeAddEditItemsPatho==0">  Add New Item </p>
            <p v-if="modeAddEditItemsPatho==1">  Edit Item </p>
          <!-- {{dataToChild}}
           {{unitPartPatho}} -->
            </header>
            <section class="modal-card-body">

             <!-- <h1>AddEditItemsPatho</h1>   

             {{dataToChild}}

             {{unitPartPatho}} -->
             <!-- type="is-danger"
                        message="This email is invalid" -->
                    <b-field label="รายการ" horizontal 
                        :type=" hasErrorDescp ?  'is-danger' :  '' "
                        :message=" hasErrorDescp ?  'this field is required' :  '' "
                        >
                        <b-input
                          v-model="dataToChild.descp" 
                          expanded
                        >  
                            
                        </b-input>
                    </b-field>


                    <b-field label="หน่วยนับ" horizontal 
                       v-if="modeAddEditItemsPatho==0"
                        >
                               <b-select placeholder="หน่วยนับ" v-model="dataToChild.unit_id" >
                                    <option  v-for="unitpartpatho in unitPartPatho" :key="unitpartpatho.id" :value="unitpartpatho.id">{{unitpartpatho.name}}</option>
                                </b-select>

                                <p class="control">
                                    <b-button type="is-primary" label="เพิ่มหน่วยนับใหม่" @click="prepareAddNewUnitPartPatho" />
                                </p>

                               
                    </b-field>
                   



                    <b-field label="ราคาขาย" horizontal 
                        >
                          <!-- <b-numberinput size="is-small"  v-model="dataToChild.sell_price" :controls=false>
                            </b-numberinput> -->
                        <b-input
                          v-model="dataToChild.sell_price" 
                          expanded
                          type="number"
                        >  
                            
                        </b-input>
                    </b-field>




                    <b-field label="สถานะ" horizontal 
                        >
                               <b-switch  type="is-success" v-model="dataToChild.enabled">{{status_caption}}</b-switch>
                    </b-field>
 
               
            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  @click="close">Cancel</b-button>
                <b-button type="is-success"
                        icon-right="cloud-upload"
                        :disabled="hasErrorDescp"
                        @click="save">
                    Save 
                </b-button>
            </footer>
        </div>
    </div>
</template>


<script>
import axios from "axios"
import {   getBaseURLforBackEnd , getConfigAxios   } from '@/utils.js'
import { mapState } from "vuex";


export default {
    name : "AddEditItemsPatho",
    computed:{
        ...mapState({
                access_token : state => state.master_data.access_token,
            }) ,
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    props:{
         dataToChild : Object,
         modeAddEditItemsPatho : Number , // 0 == Add new , 1 == Edit
         isActive : Boolean,
         
    },
    methods:{
        close(){
            this.$emit('close')
        },
        save(){
           if(this.dataToChild.descp.trim().length>0){
               //    console.log("ok")
               this.hasErrorDescp = false
               var endPoint  = ""
               var datTo = {}
               if( this.modeAddEditItemsPatho == 0 ){ // add new mode
                   endPoint = "addpartpatho"
                   datTo =     {   
                                    "descp"  : this.dataToChild.descp,
                                    "id_unit_part_patho": this.dataToChild.unit_id ,
                                    "comment_" : null,
                                    "sell_price":this.dataToChild.sell_price 
                                }
               }else{
                   endPoint = "editpartpatho"
                   datTo =     {   
                                "descp"  : this.dataToChild.descp,
                                "enabled"  : this.dataToChild.enabled,  
                                "comment_" : null ,
                                "id" :  this.dataToChild.id,
                                "sell_price":this.dataToChild.sell_price 
                               }
               }

               //


               this.isFullScreenSearching = true
               axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
               axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`,datTo, getConfigAxios())
                    .then(() => {
                         this.isFullScreenSearching = false
                         this.$emit('closeWithDataChange',{
                             "mode" : this.modeAddEditItemsPatho ,
                             "data" : datTo
                         })
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        this.isFullScreenSearching = false

                    })


           }else{
               //    console.log("not ok")  
               this.hasErrorDescp = true 
           }
        },
        loadUnitPartPatho(){
              axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
              axios.post(`${getBaseURLforBackEnd()}/api/listofunitpartpatho`, getConfigAxios())
                  .then((res) => {
                       this.unitPartPatho = res.data
                       
                       //********************************************************************* */
                       if( (this.modeAddEditItemsPatho == 0 )&&( this.unitPartPatho.length>0) ){
                           this.dataToChild.unit_id = this.unitPartPatho[0].id
                       }
                       //********************************************************************* */
                       if( (this.modeAddEditItemsPatho == 1 )&&( this.unitPartPatho.length>0) ){
                          const tmp =   this.unitPartPatho.find(dat=>dat.id==this.dataToChild.unit_id)
                        //   console.log(tmp)
                          if(tmp){
                            // console.log("do123")  
                            this.dataToChild.unit_id = tmp.id
                          }
                       }

                  })
        },
        
        
        confirmAddNewUnitPartPatho(value) {
           // console.log(value)
           if(value.trim().length>0){
                const datTo = {
                "name" : value
                }  
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/addunitpartpatho`, datTo , getConfigAxios())
                    .then(()=>{
                        this.loadUnitPartPatho()
                    })


           }else{
               this.$buefy.toast.open({
                    duration: 5000,
                    message: `text is <b>empty</b>, please check!`,
                    position: 'is-bottom',
                    type: 'is-danger'
                })
           }
           
        },    
 
        prepareAddNewUnitPartPatho() {
            this.$buefy.dialog.prompt({
                // message: 'Send your message to moon 🚀',
                message: 'Add New Unit',
                // inputAttrs: {
                //     type: 'text',
                //     placeholder: 'My Unit is...',
                //     value: 'Hello moon!'
                // },
                confirmText: 'Send',
                trapFocus: true,
                closeOnConfirm: false,
                onConfirm: (value, {close}) => {
                    this.confirmAddNewUnitPartPatho(value)
                    close()
                    // this.$buefy.toast.open(`Your message is sending...`)
                    // setTimeout(() => {
                    //     this.$buefy.toast.open(`Success message send!`)
                    //     close()
                    // }, 2000)
                }
            })
        }

    },
    data(){
        return {
            isFullScreenSearching : false,
            unitPartPatho : [],
            status_caption : "",
            dataModel : {},
            hasErrorDescp : false,
        }
    },
    watch:{
        isActive :{
            immediate : true,
            handler: function(val){
                if(val){
                  this.loadUnitPartPatho()
                  this.dataModel =JSON.parse(JSON.stringify(this.dataToChild))
                  //   console.log(this.dataModel)
                  this.status_caption = this.dataModel.enabled ? 'ใช้งาน' : 'ยกเลิก'
                   
                }
            }
        },
     
        'dataToChild.enabled' :{
                deep : true,
                handler: function (val) {
                    this.status_caption = val ? 'ใช้งาน' : 'ยกเลิก'
                }
        },



        'dataToChild.descp' :{
                deep : true,
                handler: function (val) {
                   this.hasErrorDescp = val.trim().length == 0 
                }
        }

    }
}
</script>